import { VideoProjectKanbanColumnDef } from "@/components/VideoProjectKanban";
import { VideoProject } from "@/services/bedrock";

export type CoachKanbanColumnId = "editing" | "ready_to_post" | "scheduled" | "post_failed" | "posted";

export type CoachKanbanColumnDef = VideoProjectKanbanColumnDef<CoachKanbanColumnId>;

export const COACH_KANBAN_COLUMNS: CoachKanbanColumnDef[] = [
  {
    id: "editing",
    label: "Editing",
    statuses: [
      VideoProject.Status.SUBMITTED_FOR_EDITING,
      VideoProject.Status.EDITING,
      VideoProject.Status.SUBMITTED_FOR_QA_REVIEW,
      VideoProject.Status.QA_REVIEW,
    ],
  },
  {
    id: "ready_to_post",
    label: "Ready to Post",
    statuses: [VideoProject.Status.READY_TO_POST],
  },
  {
    id: "scheduled",
    label: "Scheduled",
    statuses: [VideoProject.Status.SCHEDULED],
  },
  {
    id: "post_failed",
    label: "Post Failed",
    statuses: [VideoProject.Status.POST_FAILED],
  },
  {
    id: "posted",
    label: "Posted",
    statuses: [VideoProject.Status.POSTED],
  },
];

const STATUS_TO_COLUMN_ID = new Map<VideoProject.Status, CoachKanbanColumnId>(
  COACH_KANBAN_COLUMNS.flatMap(column => column.statuses.map(status => [status, column.id] as const))
);

export function getCoachKanbanColumnId(status: VideoProject.Status): CoachKanbanColumnId | undefined {
  return STATUS_TO_COLUMN_ID.get(status);
}
